export default __webpack_public_path__ + "static/media/Gear1.a6dd4f7f.jpg";